import { useLocation } from 'react-router-dom';

import styles from '../../css/admin/Status.module.css';
import { useLanguage } from '../../hooks/LanguageContext';
import Navbar from '../admin/NavBar';
import StatusMessage from '../admin/StatusMessage';
import translations from '../admin/translations';

export default function CouponVerifySuccess() {
  // 쿠폰은 URL에 storeNo가 없다(특정 상점에 안 묶임) — "스캔으로 돌아가기"용으로만
  // VerifyInvalid.js와 동일하게 last_storeNo 폴백을 쓴다.
  // const storeNo = localStorage.getItem('last_storeNo');
  // [2026-11-04] [스캔으로 돌아가기] 제거 — 상점번호는 상단 Header 가 ?storeNo=(로그인 상점)로 읽는다
  const location = useLocation();
  const { language } = useLanguage();
  const t = translations[language];
  const discountCouponAmt = location.state?.discountCouponAmt;

  return (
    <>
      <Navbar />
      <div className={styles.container}>
        <StatusMessage
          situation="couponVerification"
          status="success"
          desc={
            discountCouponAmt != null
              ? `${t.couponDiscountAmountLabel} ${discountCouponAmt.toLocaleString()}${t.money}`
              : undefined
          }
        />
        {/* [2026-11-04] [스캔으로 돌아가기] 제거(사용자 요청) — 앱 하단 스캔 버튼으로 다시 스캔
        <div style={{ marginTop: 12 }}>
          <Button color="orange" onClick={() => navigate(storeNo ? `/mobile/verification/${storeNo}` : '/mobile/login')}>
            {t.couponVerifyBackToScan}
          </Button>
        </div> */}
      </div>
    </>
  );
}
